import { useRetailer } from "@faire/retailer-visitor-shared/hooks/retailer/useRetailer";
import { getSessionCountry } from "@faire/retailer-visitor-shared/serialized-data/getSessionCountry";
import { useSettingAndAssignMigrateRetailerStore } from "@faire/retailer-visitor-shared/settings/useSettingMigrateRetailerStore";
import { useRetailerStore } from "@faire/retailer-visitor-shared/stores/domain/RetailerStore";
import { THREE_LETTER_EUROPE_SUPPORTED_COUNTRIES } from "@faire/web--source/common/consts/THREE_LETTER_EUROPE_SUPPORTED_COUNTRIES";
import { THREE_LETTER_PRIMARY_COUNTRY_CODES } from "@faire/web--source/common/consts/THREE_LETTER_PRIMARY_COUNTRY_CODES";
import { CurrencyUnit } from "@faire/web-api--source/faire/currency/CurrencyUnit";
export var useNationality = function() {
    var shouldUseHooksMigration = useSettingAndAssignMigrateRetailerStore();
    var retailer = useRetailer().retailer;
    var _useRetailerStore = useRetailerStore([
        "retailerCountry",
        "isAmerican",
        "isCanadian",
        "isUK",
        "isAustralian",
        "isEurope",
        "isEuropeNonUk",
        "isNewOrMigratedCanadian",
        "isInternational"
    ]), retailerCountryControl = _useRetailerStore.retailerCountry, isAmericanControl = _useRetailerStore.isAmerican, isCanadianControl = _useRetailerStore.isCanadian, isUKControl = _useRetailerStore.isUK, isAustralianControl = _useRetailerStore.isAustralian, isEuropeControl = _useRetailerStore.isEurope, isEuropeNonUkControl = _useRetailerStore.isEuropeNonUk, isNewOrMigratedCanadianControl = _useRetailerStore.isNewOrMigratedCanadian, isInternationalControl = _useRetailerStore.isInternational;
    var retailerCountry = (retailer === null || retailer === void 0 ? void 0 : retailer.country) || getSessionCountry();
    var isAmerican = retailerCountry === THREE_LETTER_PRIMARY_COUNTRY_CODES.USA;
    var isCanadian = retailerCountry === THREE_LETTER_PRIMARY_COUNTRY_CODES.CAN;
    var isUK = retailerCountry === THREE_LETTER_PRIMARY_COUNTRY_CODES.GBR;
    var isAustralian = retailerCountry === THREE_LETTER_PRIMARY_COUNTRY_CODES.AUS;
    var isEurope = THREE_LETTER_EUROPE_SUPPORTED_COUNTRIES.includes(retailerCountry);
    var isEuropeNonUk = isEurope && !isUK;
    var isNewOrMigratedCanadian = isCanadian && (retailer === null || retailer === void 0 ? void 0 : retailer.currency) === CurrencyUnit.CAD;
    var isInternational = !isAmerican && !isCanadian;
    if (shouldUseHooksMigration) {
        return {
            retailerCountry: retailerCountry,
            isAmerican: isAmerican,
            isCanadian: isCanadian,
            isUK: isUK,
            isAustralian: isAustralian,
            isEurope: isEurope,
            isEuropeNonUk: isEuropeNonUk,
            isNewOrMigratedCanadian: isNewOrMigratedCanadian,
            isInternational: isInternational
        };
    }
    return {
        retailerCountry: retailerCountryControl,
        isAmerican: isAmericanControl,
        isCanadian: isCanadianControl,
        isUK: isUKControl,
        isAustralian: isAustralianControl,
        isEurope: isEuropeControl,
        isEuropeNonUk: isEuropeNonUkControl,
        isNewOrMigratedCanadian: isNewOrMigratedCanadianControl,
        isInternational: isInternationalControl
    };
};
